const additionOptions = {
  autoplay: true,
  autoplaySpeed: 5000,
  arrows: false,
  dots: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1
};

const mobileSlider = (selector, additionOption = additionOptions) => {
  $(selector).slick({
    draggable: true,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 767,
        settings: 'unslick',
      },
    ],
    ...additionOption
  });

  $(window).on('resize orientationchange', function () {
    $(selector).slick('resize');
  });
};

export default mobileSlider;
